import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent implements OnInit {
  location = inject(Location);
  protected readonly feUtil = inject(FeUtil);

  ngOnInit(): void {

  }
}
